var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9167",
    "data-name": "Path 9167",
    d: "M17.075,2.995a10,10,0,1,0,0,14.149A10.013,10.013,0,0,0,17.075,2.995Zm-1.1,13.053a8.454,8.454,0,1,1,0-11.957A8.461,8.461,0,0,1,15.98,16.048Z",
    transform: "translate(0 -0.069)",
    fill: "#d0021b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9168",
    "data-name": "Path 9168",
    d: "M174.044,170.518l-2.193-2.191,2.193-2.191a.775.775,0,0,0-1.1-1.1l-2.195,2.192-2.195-2.192a.775.775,0,0,0-1.1,1.1l2.193,2.191-2.193,2.191a.775.775,0,0,0,1.1,1.1l2.195-2.192,2.195,2.192a.775.775,0,1,0,1.1-1.1Z",
    transform: "translate(-160.754 -158.327)",
    fill: "#d0021b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e038a96b593fd3bbeca4da539ec9d965.svg";
export { ForwardRef as ReactComponent };